const {enum_projectEnv_s} = require( "./Share_S_Enum");
const serviceAccountDev = require("../../serviceAccountKey.dev.json");
const serviceAccountPro = require("../../serviceAccountKey.pro.json");

// VUE_APP_MODE fallback to GCLOUD_PROJECT
if(!process.env.VUE_APP_MODE && process.env.GCLOUD_PROJECT){
    switch(process.env.GCLOUD_PROJECT){
       case 'travelquestdev':
           process.env.VUE_APP_MODE = enum_projectEnv_s.tq_dev
           break;
       case 'travelquest-da6b2':
           process.env.VUE_APP_MODE = enum_projectEnv_s.tq_pro
           break;
       case 'travelqueststage':
           process.env.VUE_APP_MODE = enum_projectEnv_s.tq_stage
           break;    
       
    }   
}

const currentProject_e = process.env.VUE_APP_MODE
const currentServiceAccount = (() => {
    switch(currentProject_e){
        case enum_projectEnv_s.tq_stage:
        case enum_projectEnv_s.tq_pro:
            return serviceAccountPro

        case enum_projectEnv_s.tq_local:
        case enum_projectEnv_s.tq_dev:
        default:
            return serviceAccountDev
    }
})();

export const gv_fun_env  = {

    // project
    currentProject_e,
    dbName_s : currentServiceAccount.project_id,
    dbOngoingName_s : currentServiceAccount.db_ongoing_name,
    currentServiceAccount,
    runningOnEmulator: !!process.env.FIREBASE_AUTH_EMULATOR_HOST,

    // more
    storageDebugMode: false,
    createSiteMap_b: false,
}

console.log("VUE_APP_MODE", gv_fun_env.currentProject_e)

export const gv_numbers  = {
    finishUploadFile_n: 1,

    mobileRegularWidth: 335,
    tabletRegularWidth: 600,

    screen_mobile_maxWidth: 500,
    screen_table_small_maxWidth: 1000,
    screen_tablet_big_maxWidth: 1280,

    maxImageNum_questExplore: 10,

    minPrice_displayDashboard: -1,
    minPrice_newTicket: 10,
    passwordMinLength: 6,
    shortScreenMaxHeight: 500,
    maxRiddlesNavigationDots: 13,
    defaultColAndRowsNum: 4,
    chatSaveDistance: 20,
    millisecondsInSecond: 1000,
    secondsToOldLocation_n: 5,

    lockTotalTimeInSeconds_min: 1,
    lockTotalTimeInSeconds_max: 200,

    monthsInYear: 12,

    missionPoints_min: 1,
    missionPoints_max: 50,
    leafletMinDistance_n: 0.00001,

    max_videoTimeInSeconds: 60,

    defaultRectangleSize_lng: 0.00425,
    defaultRectangleSize_lat: 0.00325,

    maxFileSizeInByte: 1000 * 1000 * 100, // 100 MB

    minRectangleSize: 0.000009,

    relevantRiddleStatus_seconds: 7,

    ticketManager_minutesToNextAudit : 480,

    dropdown_showSearchBar_minRows : 10,

    maxDurationMinutes : 60*24*7, // one week
    maxTimeExtension : 60*24*7 // one week

}

export const gv_string = {
    baseUrl : "https://TravelQuest.xyz"
}

export const gv_colorsDark = [
    '#800000',
    '#FF8C00',
    '#FFD700',
    '#008000',
    // '#008080',
    '#0000CD',
    '#8A2BE2',
    '#DA70D6',
    '#8B4513',
    '#000000',
    '#add8e6',
    '#0a7b83',
    '#ff6f69',
]